import GarConstants from "../models/GarConstants.js";
const reduxNestedKeys = {
  studiesForStep: "studiesForStep",
  resolveAlertKey: "resolveAlertResult",
  planSummaryKey: "planSummaryResult",
  hypothesisKey: "hypothesisResult",
  emptyScKey: "emptyScorecardResult",
  warningsKey: "srmAlertResultMap",
  soiKey: "scorecardInsightsResult"
};
const actionTypesPrefix = "GAR";
const createActionTypes = (resource) => ({
  LOAD: `${actionTypesPrefix}/${resource}/LOAD`,
  LOADING: `${actionTypesPrefix}/${resource}/LOADING`,
  LOADED: `${actionTypesPrefix}/${resource}/LOADED`
});
const loadAutoShutDownTypes = createActionTypes("AUTO_SHUTDOWN");
const loadSrmMoorTypes = createActionTypes("SRM_MOOR");
const loadSrmAlertTypes = createActionTypes("SRM_ALERT");
const loadScorecardDataTypes = createActionTypes("SCORECARD_DATA");
const loadMetricCategoriesTypes = createActionTypes("METRIC_CATEGORIES");
const loadExperimentPlanIdTypes = createActionTypes("EXPERIMENT_PLAN_ID");
const loadExperimentInfoTypes = createActionTypes("EXPERIMENT_INFO");
const loadScorecardsForStudiesTypes = createActionTypes("SCORECARDS_FOR_STUDIES");
const resolveQualityAlertsPrefix = `${actionTypesPrefix}/RESOLVE_ALERTS`;
const loadPlanSummaryActionPrefix = `${actionTypesPrefix}/PLAN_SUMMARY`;
const loadStudiesForStepActionPrefix = `${actionTypesPrefix}/STUDIES_FOR_STEP`;
const loadHypothesisActionPrefix = `${actionTypesPrefix}/HYPOTHESIS`;
const loadToCheckEmptyScPrefix = `${actionTypesPrefix}/EMPTY_SC`;
const loadScorecardInsightsPrefix = `${actionTypesPrefix}/SCORECARD_INSIGHTS`;
const loadMetricCategoriesPrefix = `${actionTypesPrefix}/METRIC_CATEGORIES`;
const resetStudiesForStepActionType = `${actionTypesPrefix}/RESET_STUDIES_FOR_STEP`;
const resetStudiesForStep = () => {
  return {
    type: resetStudiesForStepActionType,
    payload: null
  };
};
const setUserContext = (userContext) => {
  if (userContext.treatment == "null" && userContext.control == "null") {
    return {
      type: "noop",
      payload: userContext
    };
  }
  return {
    type: GarConstants.SET_USER_CONTEXT,
    payload: userContext
  };
};
const setPartialUserContext = (userContext, shouldReplace) => {
  if (userContext.treatment == "null" && userContext.control == "null") {
    return {
      type: "noop",
      payload: userContext
    };
  }
  if (!!shouldReplace) {
    return {
      type: GarConstants.SET_PARTIAL_USER_CONTEXT,
      // maybe use set_partial w/history.replace
      payload: userContext,
      shouldReplace
    };
  }
  return {
    type: GarConstants.SET_PARTIAL_USER_CONTEXT,
    payload: userContext
  };
};
const loadScorecardData = (payload) => {
  return {
    type: loadScorecardDataTypes.LOAD,
    payload: {
      control: payload.control,
      treatment: payload.treatment,
      workspaceid: payload.workspaceid,
      stepId: payload.stepId
    }
  };
};
const loadingScorecardData = (payload) => {
  return {
    type: loadScorecardDataTypes.LOADING,
    payload: {
      control: payload.control,
      treatment: payload.treatment,
      scorecardId: payload.scorecard.scorecardId,
      workspaceid: payload.workspaceid,
      stepId: payload.stepId
    }
  };
};
const loadedScorecardData = (payload, result) => {
  return {
    type: loadScorecardDataTypes.LOADED,
    payload: {
      result,
      control: payload.control,
      treatment: payload.treatment,
      scorecardId: payload.scorecard.scorecardId,
      workspaceid: payload.workspaceid,
      stepId: payload.stepId
    }
  };
};
const loadExperimentPlanId = (stepId) => {
  return {
    type: loadExperimentPlanIdTypes.LOAD,
    payload: {
      stepId
    }
  };
};
const loadingExperimentPlanId = (payload) => {
  return {
    type: loadExperimentPlanIdTypes.LOADING,
    payload: {
      stepId: payload.stepId
    }
  };
};
const loadExperimentInfo = (planId) => {
  return {
    type: loadExperimentInfoTypes.LOAD,
    payload: {
      planId
    }
  };
};
const loadingExperimentInfo = (payload) => {
  return {
    type: loadExperimentInfoTypes.LOADING,
    payload: {
      planId: payload.planId
    }
  };
};
const loadedExperimentInfo = (payload, result) => {
  return {
    type: loadExperimentInfoTypes.LOADED,
    payload: {
      result
    }
  };
};
const loadScorecardForStudies = (payloadData, workspaceid) => {
  return {
    type: loadScorecardsForStudiesTypes.LOAD,
    payload: {
      payloadData,
      workspaceid
    }
  };
};
const loadingScorecardForStudies = (payload) => {
  return {
    type: loadScorecardsForStudiesTypes.LOADING,
    payload
  };
};
const loadedScorecardForStudies = (payload, result) => {
  return {
    type: loadScorecardsForStudiesTypes.LOADED,
    payload: {
      studyId: payload.studyId,
      result
    }
  };
};
const loadAutoShutDown = (workspaceId, stepId) => {
  return {
    type: loadAutoShutDownTypes.LOAD,
    payload: {
      workspaceid: workspaceId,
      stepId
    }
  };
};
const loadingAutoShutDown = (payload) => {
  return {
    type: loadAutoShutDownTypes.LOADING,
    payload: {
      workspaceid: payload.workspaceid,
      stepId: payload.stepId
    }
  };
};
const loadedAutoShutDown = (payload, result) => {
  return {
    type: loadAutoShutDownTypes.LOADED,
    payload: {
      workspaceid: payload.workspaceid,
      stepId: payload.stepId,
      result
    }
  };
};
const loadSrmMoor = (workspaceId, stepId) => {
  return {
    type: loadSrmMoorTypes.LOAD,
    payload: {
      workspaceid: workspaceId,
      stepId
    }
  };
};
const loadingSrmMoor = (payload) => {
  return {
    type: loadSrmMoorTypes.LOADING,
    payload: {
      workspaceid: payload.workspaceid,
      stepId: payload.stepId
    }
  };
};
const loadedSrmMoor = (payload, result) => {
  return {
    type: loadSrmMoorTypes.LOADED,
    payload: {
      workspaceid: payload.workspaceid,
      stepId: payload.stepId,
      result
    }
  };
};
const loadSrmAlert = (workspaceId, stepId, scorecardIds) => {
  return {
    type: loadSrmAlertTypes.LOAD,
    payload: {
      workspaceid: workspaceId,
      stepId,
      scorecardIds
    }
  };
};
const loadSrmAsyncAlert = (workspaceId, stepId, scorecardId) => {
  return {
    type: loadSrmAlertTypes.LOAD,
    payload: {
      workspaceid: workspaceId,
      stepId,
      scorecardId
    }
  };
};
const loadingSrmAlert = (payload) => {
  return {
    type: loadSrmAlertTypes.LOADING,
    payload: {
      workspaceid: payload.workspaceid,
      stepId: payload.stepId,
      scorecardIds: payload.scorecardIds
    }
  };
};
const loadingSrmAsyncAlert = (payload) => {
  return {
    type: loadSrmAlertTypes.LOADING,
    payload: {
      workspaceid: payload.workspaceid,
      stepId: payload.stepId,
      scorecardId: payload.scorecardId
    }
  };
};
const loadedSrmAsyncAlert = (payload, result) => {
  return {
    type: loadSrmAlertTypes.LOADED,
    payload: {
      workspaceid: payload.workspaceid,
      stepId: payload.stepId,
      scorecardIds: [payload.scorecardId],
      result
    }
  };
};
const loadedSrmAlert = (payload, result) => {
  return {
    type: loadSrmAlertTypes.LOADED,
    payload: {
      workspaceid: payload.workspaceid,
      stepId: payload.stepId,
      scorecardIds: payload.scorecardIds,
      result
    }
  };
};
const loadMetricCategories = (metricSet, workspaceid) => {
  return {
    type: loadMetricCategoriesTypes.LOAD,
    payload: {
      metricSet,
      workspaceid
    }
  };
};
const loadingMetricCategories = (payload) => {
  return {
    type: loadMetricCategoriesTypes.LOADING,
    payload: {
      metricSet: payload.metricSet,
      workspaceid: payload.workspaceid
    }
  };
};
const loadedMetricCategories = (payload, result) => {
  return {
    type: loadMetricCategoriesTypes.LOADED,
    payload: {
      workspaceid: payload.workspaceid,
      metricSet: payload.metricSet,
      result
    }
  };
};
export {
  createActionTypes,
  loadAutoShutDown,
  loadAutoShutDownTypes,
  loadExperimentInfo,
  loadExperimentInfoTypes,
  loadExperimentPlanId,
  loadExperimentPlanIdTypes,
  loadHypothesisActionPrefix,
  loadMetricCategories,
  loadMetricCategoriesPrefix,
  loadMetricCategoriesTypes,
  loadPlanSummaryActionPrefix,
  loadScorecardData,
  loadScorecardDataTypes,
  loadScorecardForStudies,
  loadScorecardInsightsPrefix,
  loadScorecardsForStudiesTypes,
  loadSrmAlert,
  loadSrmAlertTypes,
  loadSrmAsyncAlert,
  loadSrmMoor,
  loadSrmMoorTypes,
  loadStudiesForStepActionPrefix,
  loadToCheckEmptyScPrefix,
  loadedAutoShutDown,
  loadedExperimentInfo,
  loadedMetricCategories,
  loadedScorecardData,
  loadedScorecardForStudies,
  loadedSrmAlert,
  loadedSrmAsyncAlert,
  loadedSrmMoor,
  loadingAutoShutDown,
  loadingExperimentInfo,
  loadingExperimentPlanId,
  loadingMetricCategories,
  loadingScorecardData,
  loadingScorecardForStudies,
  loadingSrmAlert,
  loadingSrmAsyncAlert,
  loadingSrmMoor,
  reduxNestedKeys,
  resetStudiesForStep,
  resetStudiesForStepActionType,
  resolveQualityAlertsPrefix,
  setPartialUserContext,
  setUserContext
};
//# sourceMappingURL=GarDucksTypes.js.map
